import React from "react";
import { Menu, Bell, Search, ChevronDown, LogOut, } from "lucide-react";
import { useNavigate } from "react-router-dom";
export default function Header({ setMobileOpen }) {
    const navigate = useNavigate();
    const logout = () => {
        sessionStorage.removeItem("backofficeAuth");
        navigate("/backoffice/login", {
            replace: true,
        });
    };
    return (
        <header className="backoffice-header">
            <div className="header-left">
                <button className="mobile-menu-btn" onClick={() => setMobileOpen(true)}><Menu size={22} /></button>
                <div className="header-search">
                    <Search size={17} />
                    <input type="text" placeholder="Search..." />
                </div>
            </div>
            <div className="header-right">
                <button className="notification-btn">
                    <Bell size={19} />
                    <span className="notification-dot"></span>
                </button>
                <div className="header-profile">
                    <div className="profile-avatar">A</div>
                    <div className="profile-info">
                        <strong>Admin</strong>
                        <span>Backoffice</span>
                    </div>
                    <ChevronDown size={16} />
                    <button className="logout-btn" onClick={logout} title="Logout"><LogOut size={17} /></button>
                </div>
            </div>
        </header>
    );
}